import { Stack, styled } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { OuterBlockContainer } from 'src/components';
import { GlobalTabs } from 'src/components/GlobalTabs';

const Content = styled(Stack)({
  height: '100%',
});

// MainPanelContainer serves as top-level wrapper for the main panel that includes all views.
// GlobalTabs sits outside OuterBlockContainer so the tab strip floats on the app canvas and
// only the content below keeps the bordered, rounded panel.
export const MainPanelContainer = () => (
  <Stack sx={{ height: '100%', minHeight: 0 }}>
    <GlobalTabs />
    <OuterBlockContainer sx={{ flex: '1 1 auto', minHeight: 0 }}>
      <Content>
        <Outlet />
      </Content>
    </OuterBlockContainer>
  </Stack>
);
